import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import get from "lodash/get"
import PropTypes from "prop-types"
import {
  useLicenseResourceMutation,
  useSchoolGroupSubscriptionsQuery
} from "@pathwright/graphql-client/src/generated"
import { getResourceTypeLabel } from "../../resource/utils"
import { getIsSubscriptionUsable } from "../../subscription/utils"
import { flattenEdges } from "../../utils/apollo"

const LicenseResourceGroupSubscriptionForm = ({
  licenseOffering,
  cohortName,
  onSuccess,
  onError
}) => {
  const { t, tc } = useTranslate()

  // NOTE: there is the potential that the user may be a school admin, in which case
  // school group subscriptions for mentor groups the user is not a member of may be included
  // in results. The backend will catch this case and throw an error if user attempts to license.
  const schoolGroupSubscriptionsQuery = useSchoolGroupSubscriptionsQuery({
    variables: {
      licenseOfferingId: licenseOffering.id
    }
  })

  const groupSubscriptions =
    flattenEdges(
      get(schoolGroupSubscriptionsQuery, "data.schoolGroupSubscriptions")
    ) || []

  // select ID of the first active group subscription
  const useGroupSubscriptionId = get(
    groupSubscriptions.filter((groupSubscription) =>
      getIsSubscriptionUsable(groupSubscription.subscription)
    ),
    "[0].id"
  )

  // NOTE: we aren't creating an order here, which seems quite unexpected!
  const [licenseResourceMutation] = useLicenseResourceMutation({
    onCompleted: (result) => onSuccess(result.licenseResource),
    onError: (error) => onError(error),
    refetchQueries: ["Cohorts"]
  })

  const submitLabel = t("Get {{ resourceType }}", {
    resourceType: getResourceTypeLabel(
      licenseOffering.resource.resource_type,
      tc
    )
  })

  const canSubmit =
    !!cohortName &&
    !schoolGroupSubscriptionsQuery.loading &&
    !!useGroupSubscriptionId

  return (
    <SubmitButton
      styleType="primary"
      size="large"
      disabled={!canSubmit}
      style={{ marginTop: "1em" }}
      onClick={() =>
        licenseResourceMutation({
          variables: {
            resource_id: licenseOffering.resource.id,
            license_offering_id: licenseOffering.id,
            use_group_subscription_id: useGroupSubscriptionId,
            role: licenseOffering.register_creator_as,
            name: cohortName
          }
        })
      }
    >
      {submitLabel}
    </SubmitButton>
  )
}

LicenseResourceGroupSubscriptionForm.displayName =
  "LicenseResourceGroupSubscriptionForm"

LicenseResourceGroupSubscriptionForm.propTypes = {
  licenseOffering: PropTypes.object.isRequired,
  cohortName: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
}

export default LicenseResourceGroupSubscriptionForm
